<template>
  <div class="wrapper-content w-100">
    <h1>Form</h1>
    <LmForm ref="lmFormRef">
      <LmEmailInput
        v-model="form.email"
        :v="$v.form.email"
        label="Email"
        placeholder="Email"
        />
      <LmTextInput
        v-model="form.text"
        :v="$v.form.text"
        label="Text"
        placeholder="Text"
        :max-length=6
        />
      <LmNumberInput
        v-model="form.number"
        :v="$v.form.number"
        label="Number"
        placeholder="Number"
        />
      <LmTextArea
        v-model="form.textArea"
        :v="$v.form.textArea"
        label="Text Area"
        placeholder="Text Area"
        :max-length=10
        />
      <LmSelect
        v-model="form.select"
        :v="$v.form.select"
        :options="options"
        label="Select"
        />
      <LmDateTime
        v-model="form.dateTime"
        :v="$v.form.dateTime"
        placeholder="Select Date"
        label="Select Date Time"
        />
      <LmDate
        v-model="form.date"
        :v="$v.form.date"
        placeholder="Select Date"
        label="Select Date"
        id="selectDate"
        :layout="['form-group']"
        />
      <LmUploadFiles
        label="File"
        ref="lmUploadFiles"
        class="mb-3"
        :dropzoneOptions="dropzoneOptions"
        @vdropzone-removed-file="fileRemoved"
        @vdropzone-success="fileUploaded"
        :v="$v.form.file"
      />
      <b-form-input
        class="mb-3"
        list="my-list-id"
        @input="inputDataList"
        :value="sizes[0].name"/>
      <b-datalist id="my-list-id">
        <option>Manual Option</option>
        <option v-for="(size, index) in sizes" :key="index">
          {{ size.name }}
        </option>
      </b-datalist>
      <LmButton
        type="button"
        buttonClass="btn-secondary"
        :value="$t('Cancel')"
        @click.native="cancelBtn"
        />
        <LmButton type="button" value="Submit" @click.native="submit()"/>
    </LmForm>
  </div>
</template>

<script>
import store from '@/store'
import formValidation from '@/components/form/LmFormValidation'

import LmForm from '@/components/form/LmForm.vue'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmSelect from '@/components/form/elements/LmSelect'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmDate from '@/components/form/elements/LmDate'
import LmButton from '@/components/form/elements/LmButton'
import LmUploadFiles from '@/components/LmUploadFiles'
export default {
  components: {
    LmForm,
    LmTextInput,
    LmNumberInput,
    LmEmailInput,
    LmButton,
    LmTextArea,
    LmSelect,
    LmDateTime,
    LmDate,
    LmUploadFiles
  },
  data () {
    return {
      sizes: [{ name: 'Small', id: 0 }, { name: 'Medium', id: 1 }, { name: 'Large', id: 2 }, { name: 'Extra Large', id: 3 }],
      form: {
        email: '',
        text: '',
        number: null,
        textArea: '',
        select: '',
        dateTime: null,
        date: null,
        file: null,
        dataList: ''
      },
      options: {
        disabledOption: 'Please select an option',
        content: ['A', 'B', 'C', 'D']
      },
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/?id=2`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${store.state.session.accessToken}`
        },
        withCredentials: true,
        thumbnailWidth: 150,
        maxFiles: 1,
        addRemoveLinks: true,
        acceptedFiles: 'image/*'
      }
    }
  },
  validations: {
    form: formValidation
  },
  methods: {
    inputDataList (event) {
      const selectedValue = this.sizes.find(el => el.name === event)
      this.form.dataList = selectedValue
    },
    fileUploaded (file, response) {
      console.log('file', file)
      console.log('response', response)
      this.form.file = response.path
    },
    fileRemoved () {
      console.log('fileremove')
      this.form.file = ''
    },
    async submit () {
      await this.$refs.lmFormRef.validationForm(this.$v)
    }
  },
  mounted () {
    if (this.$route.query.mode === 'edit') {
      this.$refs.lmFormRef.activeEditMode({
        path: 'expedientes/activos/edit/',
        id: '821268'
      })
    }
  }
}
</script>
